

















@if (dataSet) {
  <div class="dataset">
    <h1 class="field">{{dataSet.Title}}</h1>
    <div class="field">
      <h2>Summary:</h2>
      <p [innerHTML]="dataSet.Summary"></p>
    </div>
    <div class="field">
      <h2>Geographic:</h2>
      <h3>Level: {{dataSet.Geographic_Level}}</h3>
      <h3>Extent: {{dataSet.Geographic_Extent}}</h3>
    </div>
    <div class="field">
      <h2>Time Period:</h2>
      <h3>Start: {{dataSet.Time_Period_Start}}</h3>
      <h3>End: {{dataSet.Time_Period_End}}</h3>
    </div>
    <div class="field">
      <h2>Source:
        <a [href]="dataSet.Originator_Source" target="_blank">{{dataSet.Originator_Credit}}</a>
      </h2>
    </div>
    @if (dataSet.Constraints) {
      <div class="field">
        <h2>Source Use Constraints:</h2>
        <p [innerHTML]="dataSet.Constraints"></p>
      </div>
    }
    <!--
    <h2>OSU Use Constraints:</h2>
    <p [innerHTML]="dataSet.OSUConstraints"></p>
    -->
    <div class="field">
      @if (dataSet.Hosted_Source) {
        <h2>
          @if (validURL(dataSet.Hosted_Source)) {
            <a
              [href]="dataSet.Hosted_Source_Type"
              target="_blank",
              >
              Download
            </a>
          } @else {
            No Data Source
          }
        </h2>
      }
    </div>
  </div>
} @else {
  Data Set does not Exist
}

